



































import '@fullcalendar/core/vdom'
import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'

settings =
  name: 'Calendar'
  components: { Modal }

  vue:
    props: ['modal', 'actions']

    data: ->
      selectedOption: 'this_event'

    computed:
      event: -> @modal.event
      title: -> @event?.title || 'Event'
      isRRule: -> @event?.rrule?

    methods:
      close: ->
        @modal.show = false
        @selectedOption = 'this_event'

      hiRemoveRRuleEvent: ->
        switch @selectedOption
          when 'this_event' then @actions.removeInstance(@event, @modal.date)
          when 'this_and_following_events' then @actions.removeInstanceAndFollowing(@event, @modal.date)
          when 'all_events' then @actions.remove(@event)
        @close()

      hiRemoveEvent: ->
        @actions.remove(@event)
        @close()

export default VueOptions.vue settings
